import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { LeadReminder } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover/popover";

import { Badge } from "@/components/ui/badge/badge";
import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<LeadReminder>[] {
  return [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2 flex-col">
            <span>{row.index + 1}</span>
            {
              <div className="flex items-center gap-2">
                ( Created At - {format(row.original?.createdAt, "PPp")} )
              </div>
            }
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "comments",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Comment" />;
      },
      cell: ({ row }) => {
        const originData = row.original as LeadReminder & {
          lead: {
            _id: string;
            name: string;
            broker: string;
            originalStatus: string;
            status: string;
            phone: string;
          };
        };

        return (
          <div className="flex flex-col items-start gap-2">
            <span className="truncate font-medium">
              {row.getValue("comments")}
            </span>

            <Popover>
              <PopoverTrigger>
                <span className="hover:underline">( Lead )</span>
              </PopoverTrigger>
              <PopoverContent>
                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <span>Name : </span>
                    <Badge>{originData?.lead?.name}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Broker : </span>
                    <Badge>{originData?.lead?.broker}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Lead Status : </span>
                    <Badge>{originData?.lead?.originalStatus}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Calling Status : </span>
                    <Badge>{originData?.lead?.status}</Badge>
                  </div>
                  <div className="flex items-center gap-2">
                    <span>Phone : </span>
                    <Badge>{originData?.lead?.phone}</Badge>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>
        );
      },
    },

    {
      accessorKey: "disabled",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Disabled" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("disabled") === true ? "Yes" : "No"}
            </span>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    },

    {
      accessorKey: "triggered",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Triggered?" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("triggered") === true ? "Yes" : "No"}
            </span>
          </div>
        );
      },
    },

    {
      id: "actions",
      cell: ({ row }) => <DataTableRowActions row={row} />,
    },
  ];
}
